<template>
  <div class="text-xs-center" style="border-bottom: 1px solid white">
    <v-layout>
      <template v-if="isMobile">
        <v-flex>
          <v-menu offset-y max-height="400">
            <template v-slot:activator="{ on }">
              <div
                depressed
                style="border-radius: 0; width: 100%; cursor: pointer; height: 100%; border-right: 1px solid #eee"
                class="ma-0 py-2 "
                dark
                v-on="on"
              >
                <v-avatar v-on="on" size="30">
                  <img
                    class="responsive-img circle"
                    style="min-width: 100%"
                    alt
                    @error="onError"
                    :src="
                      livechatBot.pagelogo
                        ? livechatBot.pagelogo
                        : 'https://graph.facebook.com/' +
                          livechatBot.pageid +
                          '/picture?width=100&height=100&SameSite=None'
                    "
                  />
                </v-avatar>
                <v-icon>arrow_drop_down</v-icon>
              </div>
            </template>
            <LivechatPagelistMobile
              :value="$store.state.livechat.pageid"
              @changePage="changePage"
            ></LivechatPagelistMobile>
          </v-menu>
        </v-flex>
      </template>

      <template v-if="channelOptions.indexOf('facebook') != -1">
        <v-flex style="position: relative">
          <LivechatTabItem
            v-model="$store.state.livechat.app"
            app="facebook"
            @changeApp="changeApp"
          >
            <i class="fab fa-facebook"></i>
          </LivechatTabItem>

          <div class="newnotifycount" v-if="facebooknotify">
            {{ facebooknotify }}
          </div>
        </v-flex>
      </template>
      <template v-if="channelOptions.indexOf('line') != -1">
        <v-flex style="position: relative">
          <LivechatTabItem v-model="$store.state.livechat.app" app="line" @changeApp="changeApp">
            <i class="fab fa-line"></i>
          </LivechatTabItem>
          <div class="newnotifycount" v-if="linenotify">
            {{ linenotify }}
          </div>
        </v-flex>
      </template>
      <template v-if="channelOptions.indexOf('instagram') != -1">
        <v-flex style="position: relative">
          <LivechatTabItem
            v-model="$store.state.livechat.app"
            app="instagram"
            @changeApp="changeApp"
          >
            <i class="fab fa-instagram"></i>
          </LivechatTabItem>

          <div class="newnotifycount" v-if="instagramnotify">
            {{ instagramnotify }}
          </div>
        </v-flex>
      </template>
      <template v-if="channelOptions.indexOf('whatsapp') != -1">
        <v-flex style="position: relative;">
          <LivechatTabItem
            style="text-align: -webkit-center;"
            v-model="$store.state.livechat.app"
            app="whatsapp"
            @changeApp="changeApp"
          >
            <i class="fab fa-whatsapp"></i>
          </LivechatTabItem>

          <div class="newnotifycount" v-if="whatsappnotify">
            {{ whatsappnotify }}
          </div>
        </v-flex>
      </template>
      <template v-if="channelOptions.indexOf('google') != -1">
        <v-flex style="position: relative;">
          <LivechatTabItem
            style="text-align: -webkit-center;"
            v-model="$store.state.livechat.app"
            app="google"
            @changeApp="changeApp"
          >
            <i class="fab fa-google"></i>
          </LivechatTabItem>

          <div class="newnotifycount" v-if="googlenotify">
            {{ googlenotify }}
          </div>
        </v-flex>
      </template>
    </v-layout>
    <div style="position: relative">
      <v-layout
        v-if="$store.state.livechat.app === 'line'"
        id="usertype"
        class="grey lighten-3"
        :slider-color="$vuetify.theme.primary"
      >
        <v-flex
          ripple
          :key="'admin'"
          @click="changeLiveTab('user')"
          style="position: relative; border-right: 1px solid white"
        >
          <div
            class="py-2"
            style="border-bottom: 3px solid; height: 100%; cursor: pointer"
            :style="{
              'border-color': $store.state.livechat.line_tab == 'user' ? $vuetify.theme.primary : ''
            }"
          >
            {{ $t('friends') }}
            <div class="newnotifycount" v-if="chatnotify && (chatnotify.bot || chatnotify.admin)">
              {{ linenotifyFriends }}
            </div>
          </div>
        </v-flex>
        <v-flex
          ripple
          :key="'bot'"
          @click="changeLiveTab('group')"
          style="position: relative; border-right: 1px solid white"
        >
          <div
            class="py-2"
            style="border-bottom: 3px solid; height: 100%; cursor: pointer"
            :style="{
              'border-color':
                $store.state.livechat.line_tab == 'group' ? $vuetify.theme.primary : ''
            }"
          >
            {{ $t('groups') }}
            <div
              class="newnotifycount"
              v-if="chatnotify && (chatnotify.group_bot || chatnotify.group_admin)"
            >
              {{ linenotifyGroups }}
            </div>
          </div>
        </v-flex>
      </v-layout>

      <v-layout id="usertype" class="grey lighten-3" :slider-color="$vuetify.theme.primary">
        <v-flex
          xs4
          ripple
          :key="'admin'"
          @click="changeType('admin')"
          style="position: relative; border-right: 1px solid white"
        >
          <div
            class="py-2"
            style="border-bottom: 3px solid; height: 100%; cursor: pointer"
            :style="{
              'border-color': $store.state.livechat.type == 'admin' ? $vuetify.theme.primary : ''
            }"
          >
            {{ $t('Admin') }}
            <template
              v-if="
                $store.state.livechat.app == 'line' && $store.state.livechat.line_tab == 'group'
              "
            >
              <div
                class="newnotifycount"
                v-if="chatnotify && chatnotify.group_admin && chatnotify.group_admin != '0'"
              >
                {{ chatnotify.group_admin }}
              </div>
            </template>
            <template v-else>
              <div
                class="newnotifycount"
                v-if="chatnotify && chatnotify.admin && chatnotify.admin != '0'"
              >
                {{ chatnotify.admin }}
              </div>
            </template>
          </div>
        </v-flex>
        <v-flex
          xs4
          ripple
          :key="'bot'"
          @click="changeType('bot')"
          style="position: relative; border-right: 1px solid white"
        >
          <div
            class="py-2"
            style="border-bottom: 3px solid; height: 100%; cursor: pointer"
            :style="{
              'border-color': $store.state.livechat.type == 'bot' ? $vuetify.theme.primary : ''
            }"
          >
            {{ $t('chatbot') }}
            <template
              v-if="
                $store.state.livechat.app == 'line' && $store.state.livechat.line_tab == 'group'
              "
            >
              <div
                class="newnotifycount"
                v-if="chatnotify && chatnotify.group_bot && chatnotify.group_bot != '0'"
              >
                {{ chatnotify.group_bot }}
              </div>
            </template>
            <template v-else>
              <div
                class="newnotifycount"
                v-if="chatnotify && chatnotify.bot && chatnotify.bot != '0'"
              >
                {{ chatnotify.bot }}
              </div>
            </template>
          </div>
        </v-flex>
        <v-flex xs2>
          <div
            depressed
            style="border-radius: 0;  position: relative; height: 100%; cursor: pointer; border-right: 1px solid white"
            class="ma-0 py-2"
            @click="$emit('onsearch', true)"
          >
            <v-icon>search</v-icon>
          </div>
        </v-flex>
        <v-flex xs2 shrink>
          <div class="py-2 px-2" @click="showOptions = true" style="height: 100%; cursor: pointer">
            <v-icon>settings</v-icon>
          </div>
          <v-dialog v-model="showOptions" scrollable max-width="600">
            <v-card>
              <div class="text-xs-right">
                <v-btn small flat fab @click="showOptions = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <v-card-text style="max-height: 600px">
                <!-- แสดงปุ่มเลือก
                <div>
                  <label
                    class="toggle-switch small"
                    style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      :checked="$store.state.livechat.show_select_user"
                      @change="toggleShowSelectUser"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </div> -->

                <v-layout>
                  <v-flex>
                    {{ $t('Set read all') }}
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn depressed color="primary" @click="setReadAll()">
                      {{ $t('Read all') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider />
              <v-card-text v-if="showOptions && $store.state.livechat.app == 'line'">
                <LineQuota></LineQuota>
              </v-card-text>
              <v-divider />
              <v-card-text>
                <v-layout>
                  <v-flex>
                    <toggle-button
                      class="mt-2"
                      :value="mute"
                      :sync="true"
                      :color="$vuetify.theme.success"
                      @change="toggleMute"
                      :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      style="display: inline-block"
                    />
                    <span style="vertical-align: -webkit-baseline-middle;"
                      >ปิดการแจ้งเตือนด้วยเสียง</span
                    >
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import LivechatTabItem from './LivechatTabItem'
import LivechatPagelistMobile from './livechat-pagelist-mobile'
import { ToggleButton } from 'vue-js-toggle-button'
import LineQuota from './LineQuota.vue'

export default {
  props: ['newchatnotify', 'isMobile', 'pageidSelect'],
  components: {
    LivechatTabItem,
    LivechatPagelistMobile,
    ToggleButton,
    LineQuota
  },
  data() {
    return {
      mute: false,
      showOptions: false,
      packagesPageSelect:[]
    }
  },

  mounted() {
    this.getBotDetailPage()
  },
  created() {
    if (localStorage.getItem('muteChat') == null) {
      this.mute = false
    } else {
      this.mute = JSON.parse(localStorage.getItem('muteChat'))
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      livechatBot: 'selectedLivechatBot'
    }),
    channelOptions() {
      const vm = this
      let packages = this.selectedBot.packages
      if (vm.pageidSelect && vm.pageidSelect != this.selectedBot.pageid && vm.packagesPageSelect) {
        packages = vm.packagesPageSelect
      }

      let channels = []
      if (
        vm.livechatBot &&
        !['universalutilities', 'hafele', 'scgallrent', 'nvbb', 'scgworkplace'].includes(
          vm.livechatBot.theme
        )
      ) {
        channels.push('facebook')
      }
      channels.push('line')
      if (packages.includes('google')) {
        channels.push('google')
      }
      if (packages.includes('whatsapp')) {
        channels.push('whatsapp')
      }
      if (
        vm.livechatBot &&
        !['universalutilities', 'hafele', 'scgallrent', 'nvbb'].includes(vm.livechatBot.theme)
      ) {
        channels.push('instagram')
      }
      channels = channels.filter(el => packages.includes(el))
      return channels
    },
    currentLivechatExpireTime() {
      var bot = this.botlist.find(el => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (bot && bot.livechat_expireat != null) {
        var now = dayjs()
        var date = dayjs(bot.livechat_expireat)
        return parseInt(date.diff(now, 'seconds'))
      } else return null
    },
    chatnotify() {
      const vm = this
      if (vm.$store.state.livechat.app == 'facebook')
        return {
          admin: vm.newchatnotify.facebook_admin,
          bot: vm.newchatnotify.facebook_bot
        }
      else if (vm.$store.state.livechat.app == 'line')
        return {
          admin: vm.newchatnotify.line_admin,
          bot: vm.newchatnotify.line_bot,
          group_admin: vm.newchatnotify.line_group_admin,
          group_bot: vm.newchatnotify.line_group_bot
        }
      else if (vm.$store.state.livechat.app == 'instagram')
        return {
          admin: vm.newchatnotify.instagram_admin,
          bot: vm.newchatnotify.instagram_bot
        }
      else if (vm.$store.state.livechat.app == 'google')
        return {
          admin: vm.newchatnotify.google_admin,
          bot: vm.newchatnotify.google_bot
        }
      else if (vm.$store.state.livechat.app == 'whatsapp')
        return {
          admin: vm.newchatnotify.whatsapp_admin,
          bot: vm.newchatnotify.whatsapp_bot
        }
      else if (this.$store.state.livechat.app == 'whatsapp')
        return {
          admin: this.newchatnotify.whatsapp_admin,
          bot: this.newchatnotify.whatsapp_bot
        }
    },
    facebooknotify() {
      if (this.newchatnotify.facebook_bot || this.newchatnotify.facebook_admin) {
        return (
          parseFloat(this.newchatnotify.facebook_bot) +
          parseFloat(this.newchatnotify.facebook_admin)
        )
      } else return ''
    },
    linenotifyFriends() {
      if (this.newchatnotify.line_bot || this.newchatnotify.line_admin) {
        return parseFloat(this.newchatnotify.line_bot) + parseFloat(this.newchatnotify.line_admin)
      } else return ''
    },
    linenotifyGroups() {
      const vm = this
      if (vm.newchatnotify.line_group_bot || vm.newchatnotify.line_group_admin) {
        return (
          parseFloat(vm.newchatnotify.line_group_bot) +
          parseFloat(vm.newchatnotify.line_group_admin)
        )
      } else return ''
    },
    linenotify() {
      const vm = this
      if (
        vm.newchatnotify.line_bot ||
        vm.newchatnotify.line_admin ||
        vm.newchatnotify.line_group_bot ||
        vm.newchatnotify.line_group_admin
      ) {
        return (
          parseFloat(vm.newchatnotify.line_bot) +
          parseFloat(vm.newchatnotify.line_admin) +
          parseFloat(vm.newchatnotify.line_group_bot) +
          parseFloat(vm.newchatnotify.line_group_admin)
        )
      } else return ''
    },

    instagramnotify() {
      if (this.newchatnotify.instagram_bot || this.newchatnotify.instagram_admin) {
        return (
          parseFloat(this.newchatnotify.instagram_bot) +
          parseFloat(this.newchatnotify.instagram_admin)
        )
      } else return ''
    },
    googlenotify() {
      if (this.newchatnotify.google_bot || this.newchatnotify.google_admin) {
        return (
          parseFloat(this.newchatnotify.google_bot) + parseFloat(this.newchatnotify.google_admin)
        )
      } else return ''
    },
    whatsappnotify() {
      const vm = this
      if (vm.newchatnotify.whatsapp_bot || vm.newchatnotify.whatsapp_admin) {
        return (
          parseFloat(vm.newchatnotify.whatsapp_bot) + parseFloat(vm.newchatnotify.whatsapp_admin)
        )
      } else return ''
    }
  },
  methods: {
    getBotDetailPage(){
      const vm = this
      if (vm.pageidSelect && vm.pageidSelect != this.selectedBot.pageid) {
        api.getBotDetail({pageid:vm.pageidSelect},(error, response)=>{
          if (error) {
            console.error(error);
          }
          if (response.responsecode==200) {
            vm.packagesPageSelect = response.data.packages
          }
        })
      }
    },
    toggleMute() {
      this.mute = !this.mute
      localStorage.setItem('muteChat', this.mute)
    },
    async setReadAll() {
      try {
        let response = await this.post(
          'livechat/read-all',
          {},
          { params: { pageid: this.$store.state.livechat.pageid } }
        )
        if (response.success) {
          this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
          this.$emit('clearAllUnread')
        }
      } catch (error) {
        console.error(error)
      }
    },
    toggleShowSelectUser(val) {
      this.$store.commit('SET_LIVECHAT_SHOW_SELECT_USER', val.target.checked)
    },
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    changePage() {
      this.$store.commit('CLEAR_LIVECHAT_USERS')
    },
    changeApp(type) {
      this.$store.state.livechat.line_tab = 'user'
      this.$store.commit('SET_LIVECHAT_APP', type)
      this.$store.dispatch('updateLivechatUser', null)

      this.updateRoute()
    },
    changeLiveTab(name) {
      const vm = this
      vm.$nextTick(() => {
        vm.$store.state.livechat.userlist[vm.$store.state.livechat.type].offset = 0
        vm.$store.state.livechat.line_tab = name
        vm.$store.commit('SET_LIVECHAT_LINE_TAB', name)
        vm.$store.dispatch('updateLivechatUser', null)
      })
      vm.updateRoute()
    },
    changeType(name) {
      const vm = this
      vm.$store.state.livechat.userlist[name].offset = 0

      vm.$store.commit('SET_LIVECHAT_TYPE', name)
      vm.$store.dispatch('updateLivechatUser', null)
      vm.updateRoute()
    },
    updateRoute: function() {
      var query = { ...this.$route.query }
      query.app = this.app
      query.user = this.type

      this.$router
        .push({
          name: 'allinonechat',
          path: '/allinonechat',
          query: query
        })
        .catch(() => {})
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch:{
    pageidSelect:function(newVal,oldVal){
      if (newVal != oldVal) {
        this.getBotDetailPage()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatTab.vue